export const BlockCommentsLabels = {
  title: 'pin_post.block_comments_modal.title',
  description: 'pin_post.block_comments_modal.description',
  confirmButton: 'pin_post.block_comments_modal.confirm_button',
  successToast: 'pin_post.block_comments_modal.success_toast',
  errorToast: 'pin_post.block_comments_modal.error_toast'
}

export const UnblockCommentsLabels = {
  title: 'pin_post.unblock_comments_modal.title',
  description: 'pin_post.unblock_comments_modal.description',
  confirmButton: 'pin_post.unblock_comments_modal.confirm_button',
  successToast: 'pin_post.unblock_comments_modal.success_toast',
  errorToast: 'pin_post.unblock_comments_modal.error_toast'
}
